import React from 'react';
import style from './KimGroup.module.scss';
import KimSuppliersDynamicsInfo from '../../blocks/PageInfo/KimGroupIngo/KimSuppliersDynamicsInfo';

const KimSuppliersDynamics: React.FC = () => (
  <>
    <div className={style.container}>
      <KimSuppliersDynamicsInfo />
    </div>
    <div className={style.frame}>
      <iframe
        width="100%"
        height="100%"
        src="https://pix.tektorg.ru/shared/view/eb57c449-186c-4bdc-8ac3-a7677a6a3ee9"
        title="kim-suppliers-dynamics"
      />
    </div>
  </>
);

export default KimSuppliersDynamics;
